/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { RangeControl } from '@wordpress/components';
import { addFilter, applyFilters } from '@wordpress/hooks';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter( `gutenify-block-${ hookPrefix }-options-tab-content`, `Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`, ( content, { attributes, setAttributes } ) => {
	const { blockAdvanceOptions } = attributes;
	const { columns } = blockAdvanceOptions;
	return [
		...content,
		<Fragment key={ `Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content` }>
			<RangeControl
				label={ __( 'Columns' ) }
				value={ columns }
				onChange={ ( val ) => {
					const data = blockAdvanceOptions;
					data.columns = val;
					setAttributes( {
						blockAdvanceOptions: { ...data },
					} );
				} }
				min={ 1 }
				max={ applyFilters( `gutenify--${ hookPrefix }--max-columns`, 10 ) }
			/>
		</Fragment>,
	];
}
);
